<template>
  <v-container class="fill-height">
    <v-row align="start" justify="center">
      <v-col cols="12" sm="6" xl="4">
        <v-card flat>
          <v-card-title>About Us</v-card-title>
          <v-divider></v-divider>
          <v-list>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-telegram</v-icon>
              </v-list-item-icon>

              <v-list-item-content>Telegram Blog Channel</v-list-item-content>
              <v-list-item-action-text title="Join">
                <v-btn outlined color="primary" small href="https://t.me/tradingIF">JOIN NOW</v-btn>
              </v-list-item-action-text>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-telegram</v-icon>
              </v-list-item-icon>

              <v-list-item-content>Telegram Support Group</v-list-item-content>
              <v-list-item-action-text title="Join">
                <v-btn
                  color="primary"
                  small
                  outlined
                  href="https://t.me/joinchat/H1tHIxlqKjcIKdDErLJpZQ"
                >JOIN NOW</v-btn>
              </v-list-item-action-text>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" xl="4">
        <v-card flat>
          <v-card-title>Blogs</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div ref="telegramPost"></div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      postLink: "tradingIF/190"
    };
  },
  mounted() {
    // create script with given params
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://telegram.org/js/telegram-widget.js?7";
    script.setAttribute("data-telegram-post", this.postLink);
    script.setAttribute("data-width", "100%");

    this.$refs.telegramPost.appendChild(script);
  }
};
</script>